export default __webpack_public_path__ + "static/mightyc-teaser2-mobile-f268bc5f7dee575554eb38cadc9b8282.png";